export default "__VITE_ASSET__DmKYQ8gr__"